import { RoceValues, RoceResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// ROCE = Operating profit / (Total assets - Interest-free liabilities)
export function calculateRoce(values: RoceValues, t?: ToolsTranslations['roce']): RoceResult {
  const { operatingProfit, totalAssets, interestFreeLiabilities } = values;
  if (operatingProfit < 0 || totalAssets <= 0 || interestFreeLiabilities < 0) {
    return { percent: null, isValid: false, message: t?.invalid.generic };
  }
  const capitalEmployed = totalAssets - interestFreeLiabilities;
  if (capitalEmployed <= 0) {
    return { percent: null, isValid: false, message: t?.invalid.capitalNonPositive };
  }
  const roce = (operatingProfit / capitalEmployed) * 100;
  const percent = Math.round(roce * 10) / 10; // one decimal
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


